module.exports = __webpack_public_path__ + "img/36.b48930ad.jpeg";